<dx-validation-group #validatorPortalAccountName>
  <dx-responsive-box #portalAccountContainer class="portal-account-container">
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>

    <dxi-col></dxi-col>
    <dxi-col></dxi-col>
    <dxi-col screen="md lg"></dxi-col>

    <ng-container *ngIf="!!registrationEditor && !isUserCreated">
      <dxi-item>
        <dxi-location
          screen="md lg"
          [row]="0"
          [col]="0"
          [colspan]="3"
        ></dxi-location>
        <dxi-location
          screen="xs sm"
          [row]="0"
          [col]="0"
          [colspan]="2"
        ></dxi-location>

        <div *dxTemplate class="input-container">
          <div class="input-wrapper text-center">
            Please select the account user you are registering for.
          </div>
        </div>
      </dxi-item>
      <dxi-item>
        <dxi-location
          screen="md lg"
          [row]="1"
          [col]="0"
          [colspan]="3"
        ></dxi-location>
        <dxi-location
          screen="xs sm"
          [row]="1"
          [col]="0"
          [colspan]="2"
        ></dxi-location>

        <div *dxTemplate class="input-container">
          <div class="input-wrapper row-container">
            <div class="sub-title-container">
              Account User:
              <span class="required-asterisk">*</span>
            </div>
            <dx-radio-group
              displayExpr="fullName"
              valueExpr="ownerIdentifier"
              layout="vertical"
              [dataSource]="registrationEditor.owners"
              [(value)]="selectedOwnerIdentifier"
              (onValueChanged)="onOwnerSelection()"
            ></dx-radio-group>
          </div>
        </div>
      </dxi-item>

      <dxi-item>
        <dxi-location
          screen="md lg"
          [row]="2"
          [col]="0"
          [colspan]="3"
        ></dxi-location>
        <dxi-location
          screen="xs sm"
          [row]="2"
          [col]="0"
          [colspan]="2"
        ></dxi-location>

        <div *dxTemplate class="input-container">
          <div *ngIf="isContactTypeVisible" class="input-wrapper row-container">
            <div class="sub-title-container">
              First Name:
              <span
                *ngIf="!selectedOwnerRaw.isCompanyOwner"
                class="required-asterisk"
              >
                *
              </span>
            </div>
            <dx-text-box
              placeholder="First Name"
              class="text-input"
              [(value)]="selectedOwnerRaw.firstName"
              [readOnly]="isOwnerNameTextFieldsReadOnly()"
              validationMessageMode="always"
            >
              <dx-validator>
                <dxi-validation-rule
                  *ngIf="!selectedOwnerRaw?.isCompanyOwner"
                  type="required"
                  message="First Name is required"
                ></dxi-validation-rule>
              </dx-validator>
            </dx-text-box>
          </div>
        </div>
      </dxi-item>
      <dxi-item>
        <dxi-location
          screen="md lg"
          [row]="3"
          [col]="0"
          [colspan]="3"
        ></dxi-location>
        <dxi-location
          screen="xs sm"
          [row]="3"
          [col]="0"
          [colspan]="2"
        ></dxi-location>

        <div *dxTemplate class="input-container">
          <div
            *ngIf="isContactTypeVisible && !selectedOwnerRaw.isCompanyOwner"
            class="input-wrapper row-container"
          >
            <div class="sub-title-container">Middle Name:</div>
            <dx-text-box
              [placeholder]="getPlaceHolderForMiddleName()"
              class="text-input"
              [(value)]="selectedOwnerRaw.middleName"
              [readOnly]="isOwnerNameTextFieldsReadOnly()"
            ></dx-text-box>
          </div>
        </div>
      </dxi-item>
      <dxi-item>
        <dxi-location
          screen="md lg"
          [row]="4"
          [col]="0"
          [colspan]="3"
        ></dxi-location>
        <dxi-location
          screen="xs sm"
          [row]="4"
          [col]="0"
          [colspan]="2"
        ></dxi-location>

        <div *dxTemplate class="input-container">
          <div *ngIf="isContactTypeVisible" class="input-wrapper row-container">
            <div class="sub-title-container">
              Last Name:
              <span class="required-asterisk">*</span>
            </div>
            <dx-text-box
              placeholder="Last Name"
              class="text-input"
              [(value)]="selectedOwnerRaw.lastName"
              [readOnly]="isOwnerNameTextFieldsReadOnly()"
              validationMessageMode="always"
            >
              <dx-validator>
                <dxi-validation-rule
                  type="required"
                  message="Last Name is required"
                ></dxi-validation-rule>
              </dx-validator>
            </dx-text-box>
          </div>
        </div>
      </dxi-item>
      <dxi-item>
        <dxi-location
          screen="md lg"
          [row]="5"
          [col]="0"
          [colspan]="3"
        ></dxi-location>
        <dxi-location
          screen="xs sm"
          [row]="5"
          [col]="0"
          [colspan]="2"
        ></dxi-location>

        <div *dxTemplate class="input-container">
          <div *ngIf="isContactTypeVisible" class="input-wrapper row-container">
            <div class="sub-title-container">
              Contact Type:
              <span class="required-asterisk">*</span>
            </div>
            <dx-select-box
              class="select-box-input"
              displayExpr="displayText"
              valueExpr="contactTypeId"
              [showClearButton]="true"
              [searchEnabled]="true"
              [dataSource]="registrationEditor.contactTypes"
              [(value)]="selectedOwnerRaw.contactTypeId"
              (onValueChanged)="onContactTypeValueChanged()"
              validationMessageMode="always"
            >
              <dx-validator>
                <dxi-validation-rule
                  type="required"
                  message="Contact Type is required"
                ></dxi-validation-rule>
              </dx-validator>
            </dx-select-box>
          </div>
        </div>
      </dxi-item>

      <dxi-item>
        <dxi-location
          screen="md lg"
          [row]="7"
          [col]="0"
          [colspan]="3"
        ></dxi-location>
        <dxi-location
          screen="xs sm"
          [row]="7"
          [col]="0"
          [colspan]="2"
        ></dxi-location>

        <div *dxTemplate class="btn-wrapper">
          <dx-button
            #btnPrevious
            text="Back"
            class="full-width-button back-button"
            type="default"
            (onClick)="btnPreviousClick()"
          ></dx-button>
        </div>
      </dxi-item>
      <dxi-item>
        <dxi-location
          screen="md lg"
          [row]="8"
          [col]="0"
          [colspan]="3"
        ></dxi-location>
        <dxi-location
          screen="xs sm"
          [row]="8"
          [col]="0"
          [colspan]="2"
        ></dxi-location>

        <div *dxTemplate class="btn-wrapper">
          <dx-button
            *ngIf="!!isEmailCommunicationRequired"
            text="Continue"
            class="full-width-button register-button"
            type="default"
            (onClick)="btnNextClick()"
          ></dx-button>
          <dx-button
            *ngIf="!isEmailCommunicationRequired"
            text="Register"
            class="full-width-button register-button"
            type="default"
            (onClick)="btnRegisterClick()"
          ></dx-button>
        </div>
      </dxi-item>
    </ng-container>
    <ng-container *ngIf="isUserCreated">
      <dxi-item>
        <dxi-location [row]="0" [col]="0" [colspan]="2"></dxi-location>
        <div *dxTemplate class="success-message">
          Your account has been successfully created and a confirmation email
          has been sent to you to activate the account. Please be aware that
          your Spam Protection may incorrectly identify the Activation Email as
          spam.
        </div>
      </dxi-item>
      <dxi-item>
        <dxi-location [row]="1" [col]="0" [colspan]="2"></dxi-location>
        <div *dxTemplate class="btn-wrapper btn-wrapper-align-center">
          <dx-button
            #btnLogin
            text="Back to Login"
            class="back-to-login-button"
            type="default"
            (onClick)="btnBackToLogin()"
          ></dx-button>
        </div>
      </dxi-item>
    </ng-container>
  </dx-responsive-box>
</dx-validation-group>

<dx-load-panel
  #loadPanelLogin
  shadingColor="rgba(0,0,0,0.4)"
  [position]="{ of: '#portalAccountContainer' }"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
></dx-load-panel>

<cc-message-box #messageBox></cc-message-box>
